import {
  ApiResponse,
  CardRenewalDraft,
  CardRenewalDraftFilters,
  CardRenewalStatistics,
  CardRenewalTriggerResponse,
  UpdateCardRenewalAddressRequest,
  PayCenterHistoryEntry,
} from '@mygate/common';
import { api } from './api';

class CardRenewalService {
  async listDrafts(filters?: CardRenewalDraftFilters): Promise<ApiResponse<CardRenewalDraft[]>> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const endpoint = queryString ? `/api/staff/card-renewals?${queryString}` : '/api/staff/card-renewals';
    return api.get<CardRenewalDraft[]>(endpoint);
  }

  async getStatistics(): Promise<ApiResponse<CardRenewalStatistics>> {
    return api.get<CardRenewalStatistics>('/api/staff/card-renewals/statistics');
  }

  async getDraft(id: string): Promise<ApiResponse<CardRenewalDraft>> {
    return api.get<CardRenewalDraft>(`/api/staff/card-renewals/${id}`);
  }

  async updateAddress(id: string, data: UpdateCardRenewalAddressRequest): Promise<ApiResponse<CardRenewalDraft>> {
    return api.patch<CardRenewalDraft>(`/api/staff/card-renewals/${id}/address`, data);
  }

  async approveDraft(id: string): Promise<ApiResponse<CardRenewalDraft>> {
    return api.put<CardRenewalDraft>(`/api/staff/card-renewals/${id}/approve`);
  }

  async rejectDraft(id: string, reason: string): Promise<ApiResponse<CardRenewalDraft>> {
    if (!reason) {
      throw new Error('Rejection reason is required');
    }
    return api.put<CardRenewalDraft>(`/api/staff/card-renewals/${id}/reject`, { reason });
  }

  async triggerExpirationCheck(options?: {
    daysBeforeExpiration?: number;
    batchSize?: number;
  }): Promise<ApiResponse<CardRenewalTriggerResponse>> {
    return api.post<CardRenewalTriggerResponse>('/api/staff/card-renewals/trigger-check', options || {});
  }

  async getCardOrderHistory(cardOrderId: string): Promise<PayCenterHistoryEntry[]> {
    const response = await api.get<PayCenterHistoryEntry[]>(
      `/api/staff/card-orders/${cardOrderId}/paycenter-history`,
    );
    return response.data || [];
  }
}

export const cardRenewalService = new CardRenewalService();
